"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var registration_form_provider_1 = require("../../services/registration-form.provider");
var core_2 = require("@ngx-translate/core");
var operators_1 = require("rxjs/operators");
var Step1Component = /** @class */ (function () {
    function Step1Component(applicationRef, registrationFormProvider, translation) {
        this.applicationRef = applicationRef;
        this.registrationFormProvider = registrationFormProvider;
        this.translation = translation;
        this.signinWithSocial = false;
        this.next = new core_1.EventEmitter();
        this.passwordInputFocused = false;
        this.registrationForm = registrationFormProvider.registrationForm;
    }
    Step1Component.prototype.ngOnInit = function () {
        var _this = this;
        this.translation
            .get('placeholders')
            .pipe(operators_1.take(1))
            .subscribe(function (data) { return (_this.placholders = data); });
    };
    Step1Component.prototype.ngAfterViewInit = function () {
        setTimeout(function () { return document.querySelector('[name="firstName"]').focus(); }, 300);
    };
    Step1Component.prototype.page1Valid = function () {
        return this.registrationFormProvider.isStep1Valid();
    };
    Step1Component.prototype.showValidationErrors = function () {
        this.registrationFormProvider.step1MarkAsTouched();
    };
    Step1Component.prototype.goToStep2 = function () {
        if (!this.page1Valid()) {
            this.showValidationErrors();
        }
        else {
            this.next.emit();
        }
    };
    Object.defineProperty(Step1Component.prototype, "validationTipsErrors", {
        get: function () {
            var validators = {
                numbers: false,
                mixedCase: false,
                specialChars: false,
                length: false
            };
            return tslib_1.__assign({}, validators, this.registrationForm.controls['password'].errors);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Step1Component.prototype, "isPasswordTipsOpen", {
        get: function () {
            if (this.passwordInputFocused) {
                return true;
            }
            // if (!!this.registrationForm.controls['password'].value) {
            //   return true;
            // }
            return this.registrationForm.controls['password'].invalid && this.registrationForm.controls['password'].touched;
        },
        enumerable: true,
        configurable: true
    });
    return Step1Component;
}());
exports.Step1Component = Step1Component;
